module.exports = __webpack_public_path__ + "img/footer-logo.279b9e4d.png";